import cadeia from './cadeia'
import grupoIndicador from './grupo-indicador'
import indicador from './indicador'
import safra from './safra'
import estado from './estado'
import regiao from './regiao'
import cidade from './cidade'
import list from './list'

export default {
  namespaced: true,
  modules: {
    cadeia,
    grupoIndicador,
    indicador,
    safra,
    estado,
    regiao,
    cidade,
    list
  }
}
